export default __webpack_public_path__ + "user_icon.7c1deb.svg";